import {FC} from 'react'
import {SearchSelectBox} from 'jbc-front/components/SearchForm'
import {useFormContext, useWatch} from 'react-hook-form'
import {isString} from 'lodash'
import {AddedField, AddFieldSelect} from 'components/SearchForm/AdditionalSearchField'
import {useAutosaveAddedFields} from 'hooks/useAutosaveAddedFields'
import {FormerName} from './AddedFields/FormerName'
import {Birthday} from './AddedFields/Birthday'
import {Genders} from './AddedFields/Genders'
import {Countries} from './AddedFields/Countries'
import {Prefectures} from './AddedFields/Prefectures'
import {NationalTypes} from './AddedFields/NationalTypes'
import {RetiredAt} from './AddedFields/RetiredAt'
import {RetireTypes} from './AddedFields/RetireTypes'
import {HasDependents} from './AddedFields/HasDependents'
import {MaritalStatuses} from './AddedFields/MaritalStatuses'
import {RemunerationTypes} from './AddedFields/RemunerationTypes'
import {HandicapTypes} from './AddedFields/HandicapTypes'
import {WidowTypes} from './AddedFields/WidowTypes'
import {WorkingStudentTypes} from './AddedFields/WorkingStudentTypes'
import {Tags} from './AddedFields/Tags'
import {Skills} from './AddedFields/Skills'
import {Qualifications} from './AddedFields/Qualifications'
import {Languages} from './AddedFields/Languages'
import {Projects} from './AddedFields/Projects'
import {addOptions, Schema} from './schema'

export const AddedFields: FC = () => {
  const {control, setValue} = useFormContext<Schema>()
  const addedFields = useWatch({control, name: 'addedFields'}) || []
  useAutosaveAddedFields<Schema>('addedFields')

  return (
    <>
      {addedFields.map((field) => (
        <AddedField
          key={field}
          onRemove={() => {
            setValue(
              'addedFields',
              addedFields.filter((f) => f !== field)
            )
          }}
        >
          {renderAddedField(field)}
        </AddedField>
      ))}
      <AddFieldSelect>
        <SearchSelectBox
          options={addOptions.filter(({value}) => !addedFields?.includes(value))}
          width={220}
          closeOnSelect={false}
          placeholder="検索条件追加"
          input={{
            onChange: (v) => {
              if (isString(v)) {
                setValue('addedFields', [...addedFields, v])
              }
            },
          }}
          onSelect={() => {} /* no op */}
        />
      </AddFieldSelect>
    </>
  )
}

const renderAddedField = (field: string) => {
  switch (field) {
    case 'former_name':
      return <FormerName />
    case 'birthday':
      return <Birthday />
    case 'genders':
      return <Genders />
    case 'countries':
      return <Countries />
    case 'prefecture_ids':
      return <Prefectures />
    case 'national_types':
      return <NationalTypes />
    case 'retired_at':
      return <RetiredAt />
    case 'retire_types':
      return <RetireTypes />
    case 'has_dependents':
      return <HasDependents />
    case 'marital_statuses':
      return <MaritalStatuses />
    case 'remuneration_types':
      return <RemunerationTypes />
    case 'handicap_types':
      return <HandicapTypes />
    case 'widow_types':
      return <WidowTypes />
    case 'working_student_types':
      return <WorkingStudentTypes />
    case 'tags':
      return <Tags />
    case 'skills':
      return <Skills />
    case 'qualifications':
      return <Qualifications />
    case 'languages':
      return <Languages />
    case 'projects':
      return <Projects />
    default:
      if (process.env['NODE_ENV'] === 'development') {
        console.error(`Unknown added field: ${field}`)
      }
      return null
  }
}
